function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.5 3.135v.668a.485.485 0 00.129.392.441.441 0 00.642 0l1.495-1.116a.458.458 0 00.084-.063l.017-.012a.494.494 0 00.109-.494.469.469 0 00-.242-.28L9.271 1.14a.441.441 0 00-.642 0 .485.485 0 00-.13.39v.658H1.454A.464.464 0 001 2.661c0 .262.203.474.454.474H8.5z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.5
});

var SvgArrowRightSmall = function SvgArrowRightSmall(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 5,
    viewBox: "0 0 12 5",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml,%3Csvg width='12' height='5' viewBox='0 0 12 5' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8.49912 3.13489V3.80346C8.48326 3.9427 8.52651 4.08782 8.62887 4.19461C8.80624 4.37966 9.09388 4.37956 9.27137 4.19439L10.7661 3.07917C10.7957 3.062 10.8239 3.04111 10.8501 3.01647L10.8668 3.00399C10.9561 2.91087 11.0005 2.78867 11 2.66665C11.0002 2.6137 10.992 2.5607 10.9753 2.51007C10.9353 2.38599 10.8474 2.28486 10.7345 2.23057L9.27137 1.13896C9.09388 0.953774 8.80624 0.953675 8.62887 1.13869C8.52651 1.24552 8.48326 1.39065 8.49912 1.52989V2.18724H1.45447C1.20345 2.18724 1 2.39938 1 2.6611C1 2.92278 1.20345 3.13489 1.45447 3.13489H8.49912Z' fill='currentColor' stroke='currentColor' stroke-width='0.5' /%3E %3C/svg%3E";
export { SvgArrowRightSmall as ReactComponent };